import { pt2px } from '@/utils/converter'
import React, { useRef } from 'react'
import HTMLFlipBook from 'react-pageflip'
import Image from 'next/image'
import { useRouter } from 'next/router'

const formatImageUrl = (url: string | undefined) => {
  if (!url) return '/placeholder.png';
  
  // If it's already a full URL, return it
  if (url.startsWith('http')) return url;
  
  // Remove any leading slashes from the path
  const cleanPath = url.replace(/^\/+/, '');
  
  // Construct the CDN URL, ensuring no double slashes
  const cdnUrl = process.env.NEXT_PUBLIC_CDN_URL?.replace(/\/+$/, '') || '';
  return `${cdnUrl}/${cleanPath}`;
};

interface Props {
  pages: any
  pages_predefined_texts: any
  pages_dedication_texts: any
  product: any
  inputDedication: any
  cover_pages_predefined_texts: any
  cover_pages: any

  isRtl?: boolean
  width?: number
  height?: number
  minWidth?: number
  maxWidth?: number
  minHeight?: number
  maxHeight?: number
  desktopRef?: any
}
export default function Book({
  pages,
  pages_predefined_texts,
  isRtl = true,
  pages_dedication_texts,
  product,
  inputDedication,
  cover_pages,
  cover_pages_predefined_texts,
  width = 600,
  height = 600,
  minWidth = 415,
  maxWidth = 600,
  minHeight = 600,
  maxHeight = 833,
  desktopRef,
}: Props) {
  const modified_pages: any = []

  const router = useRouter()
  const name =
    router.query.name != undefined ? (router.query.name as string) : ''
  const [imageWidth, setImageWidth] = React.useState(300)

  const handleImageLoad = (event: any) => {
    const elem = document.querySelector('.--simple img')
    if (elem) {
      if (elem.clientWidth != 0) {
        setImageWidth(elem.clientWidth)
      }
    }
  }
  if (typeof window == undefined) {
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        const elem = document.querySelector('.--simple img')
        if (elem) {
          if (elem.clientWidth != 0) {
            setImageWidth(elem.clientWidth)
          }
        }
      }
    })
  }
  React.useEffect(() => {
    if (imageWidth === 0) {
      const elem = document.querySelector('.--simple img')
      if (elem) {
        if (elem.clientWidth != 0) {
          setImageWidth(elem.clientWidth)
        }
      }
    }
  }, [imageWidth])

  const getCalculatedXCoord = (X_coord_percent: number) => {
    const cover_calculation = JSON.parse(
      cover_pages_predefined_texts.filter(
        (x: any) => x.page == (0).toString(),
      )[0].dimensions,
    )['width']
    const X_coord_percent_calculated =
      (cover_calculation * X_coord_percent) / (cover_calculation * 2)
    return X_coord_percent_calculated
  }
  const getTextAlignment = (text_align: string) => {
    if (text_align == 'C') {
      return 'center'
    }
    if (text_align == 'R') {
      return 'right'
    }
    if (text_align == 'L') {
      return 'left'
    }
    return 'left'
  }
  if (pages) {
    //Swap two elements
    for (let index = pages.length - 1; index >= 0; index--) {
      if ((index + 1) % 2 === 0) {
        continue
      }
      modified_pages.push(pages[index + 1], pages[index])
      if (!product.is_rtl) {
        //modified_pages.reverse()
      }
    }
    if (isRtl && product.is_rtl) {
      return (
        // @ts-ignore: Unreachable code error
        <HTMLFlipBook
          width={width}
          height={height}
          size="stretch"
          minWidth={minWidth}
          maxWidth={maxWidth}
          minHeight={minHeight}
          startPage={isRtl && product.is_rtl ? modified_pages.length + 1 : 0}
          showCover={true}
          maxHeight={maxHeight}
          ref={desktopRef}
          maxShadowOpacity={0.5}
          mobileScrollSupport={true}>
          <div className="relative">
            {cover_pages_predefined_texts
              ?.filter((x: any) => x.page == '1')[0]
              ?.predefined_texts?.map((item: any, idx: number) => {
                let dimensions = JSON.parse(
                  cover_pages_predefined_texts.filter(
                    (x: any) => x.page == '1',
                  )[0]['dimensions'],
                )
                return (
                  <div
                    className="texts absolute"
                    key={idx}
                    id={item.X_coord_percent}
                    data-attribute={`${imageWidth}-${item.max_width}-${dimensions.width
                      }-${pt2px(dimensions.width)}`}
                    style={{
                      fontSize:
                        (imageWidth * item.font_size) / pt2px(dimensions.width),
                      textAlign: getTextAlignment(item.text_align),
                      width:
                        (imageWidth * item.max_width) / pt2px(dimensions.width),
                      top: item.Y_coord_percent + '%',
                      lineHeight: item.line_height,
                      whiteSpace: 'pre-wrap',
                      left: item.X_coord_percent * 2 + '%',
                      color: item.color,
                      fontFamily: item.font_face,
                    }}
                    dangerouslySetInnerHTML={{ __html: item.text }}></div>
                )
              })}
            <Image
              alt="cover"
              className="w-full h-full object-cover"
              width={700}
              priority={true}
              height={700}
              onLoad={handleImageLoad}
              onError={(e: any) => {
                console.error('Failed to load image:', e);
                // Optionally set a fallback image
                e.target.src = '/placeholder.png';
              }}
              src={formatImageUrl(cover_pages[1])}
            />
          </div>

          {/*
           * If It is Arabic Language
           */}

          {modified_pages.map((page: any, index: number) => {
            return (
              <div className="relative" key={index}>
                <Image
                  className={`block w-full book-image img-${index}`}
                  alt="book-image"
                  width={700}
                  height={700}
                  onLoad={handleImageLoad}
                  onError={(e: any) => {
                    console.error('Failed to load image:', e);
                    // Optionally set a fallback image
                    e.target.src = '/placeholder.png';
                  }}
                  priority={true}
                  src={formatImageUrl(page)}
                  style={{ display: 'block' }}
                />

                {pages_dedication_texts
                  .filter(
                    (x: any) =>
                      x.page == (modified_pages.length - index - 1).toString(),
                  )[0]
                  ?.dedication_texts?.map((item: any, idx: number) => {
                    let dimensions = JSON.parse(
                      pages_dedication_texts.filter(
                        (x: any) =>
                          x.page ==
                          (modified_pages.length - index - 1).toString(),
                      )[0]['dimensions'],
                    )
                    let book_img = document.querySelector('.book-image')
                    if (item) {
                      return (
                        <div
                          className="texts absolute"
                          key={idx}
                          data-attribute={`${item.X_coord_percent}`}
                          style={{
                            fontSize:
                              (imageWidth * item.font_size) /
                              pt2px(dimensions.width),
                            textAlign: getTextAlignment(item.text_align),
                            width:
                              (imageWidth * item.max_width) /
                              pt2px(dimensions.width),
                            top: item.Y_coord_percent + '%',
                            lineHeight: item.line_height,
                            color: item.color,
                            whiteSpace: 'pre-wrap',
                            left: item.X_coord_percent + '%',
                            fontFamily: item.font_face,
                          }}>
                          {inputDedication.replace(
                            '{basmti}',
                            name ?? product.replace_name,
                          )}
                        </div>
                      )
                    } else {
                      return <></>
                    }
                  })}
                {pages_predefined_texts
                  .filter(
                    (x: any) =>
                      x.page == (modified_pages.length - index - 1).toString(),
                  )[0]
                  ?.predefined_texts?.map((item: any, idx: number) => {
                    let dimensions = JSON.parse(
                      pages_predefined_texts.filter(
                        (x: any) =>
                          x.page ==
                          (modified_pages.length - index - 1).toString(),
                      )[0]['dimensions'],
                    )
                    let book_img = document.querySelector('.book-image')
                    if (item) {
                      return (
                        <div
                          className="texts absolute"
                          key={idx}
                          style={{
                            fontSize:
                              (imageWidth * item.font_size) /
                              pt2px(dimensions.width),
                            textAlign: getTextAlignment(item.text_align),
                            width:
                              (imageWidth * item.max_width) /
                              pt2px(dimensions.width),
                            top: item.Y_coord_percent + '%',
                            lineHeight: item.line_height,
                            whiteSpace: 'pre-wrap',
                            color: item.color,
                            left: item.X_coord_percent + '%',
                            fontFamily: item.font_face,
                          }}
                          dangerouslySetInnerHTML={{ __html: item.text }}></div>
                      )
                    } else {
                      return <></>
                    }
                  })}
              </div>
            )
          })}
          <div className="relative start-cover">
            {cover_pages_predefined_texts
              ?.filter((x: any) => x.page == '0')[0]
              ?.predefined_texts?.map((item: any, idx: number) => {
                let dimensions = JSON.parse(
                  cover_pages_predefined_texts.filter(
                    (x: any) => x.page == '0',
                  )[0]['dimensions'],
                )
                return (
                  <div
                    className="texts absolute"
                    key={idx}
                    id={item.X_coord_percent}
                    data-attribute={`${imageWidth}-${item.max_width}-${dimensions.width
                      }-${pt2px(dimensions.width)}`}
                    style={{
                      fontSize:
                        (imageWidth * item.font_size) / pt2px(dimensions.width),
                      textAlign: getTextAlignment(item.text_align),
                      width:
                        (imageWidth * item.max_width) / pt2px(dimensions.width),
                      top: item.Y_coord_percent + '%',
                      lineHeight: item.line_height,
                      whiteSpace: 'pre-wrap',
                      left: item.X_coord_percent * 2 + '%',
                      color: item.color,
                      fontFamily: item.font_face,
                    }}
                    dangerouslySetInnerHTML={{ __html: item.text }}></div>
                )
              })}
            <Image
              alt="cover"
              className="w-full h-full object-cover"
              width={700}
              height={700}
              onLoad={handleImageLoad}
              onError={(e: any) => {
                console.error('Failed to load image:', e);
                // Optionally set a fallback image
                e.target.src = '/placeholder.png';
              }}
              src={formatImageUrl(cover_pages[0])}
            />
          </div>
        </HTMLFlipBook>
      )
    } else {
      // If English Language
      return (
        // @ts-ignore: Unreachable code error
        <HTMLFlipBook
          width={width}
          height={height}
          size="stretch"
          ref={desktopRef}
          minWidth={minWidth}
          maxWidth={maxWidth}
          minHeight={minHeight}
          startPage={0}
          showCover={true}
          maxHeight={maxHeight}
          maxShadowOpacity={0.5}
          mobileScrollSupport={true}>
          <div className="relative">
            {cover_pages_predefined_texts
              ?.filter((x: any) => x.page == '1')[0]
              ?.predefined_texts?.map((item: any, idx: number) => {
                let dimensions = JSON.parse(
                  cover_pages_predefined_texts.filter(
                    (x: any) => x.page == '1',
                  )[0]['dimensions'],
                )
                return (
                  <div
                    className="texts absolute"
                    key={idx}
                    id={item.X_coord_percent}
                    data-attribute={`${imageWidth}-${item.max_width}-${dimensions.width
                      }-${pt2px(dimensions.width)}`}
                    style={{
                      fontSize:
                        (imageWidth * item.font_size) / pt2px(dimensions.width),
                      textAlign: getTextAlignment(item.text_align),
                      width:
                        (imageWidth * item.max_width) / pt2px(dimensions.width),
                      top: item.Y_coord_percent + '%',
                      lineHeight: item.line_height,
                      whiteSpace: 'pre-wrap',
                      left: item.X_coord_percent * 2 + '%',
                      color: item.color,
                      fontFamily: item.font_face,
                      direction: 'ltr',
                    }}
                    dangerouslySetInnerHTML={{ __html: item.text }}></div>
                )
              })}
            <Image
              alt="cover"
              className="w-full h-full object-cover"
              width={700}
              priority={true}
              height={700}
              onLoad={handleImageLoad}
              onError={(e: any) => {
                console.error('Failed to load image:', e);
                // Optionally set a fallback image
                e.target.src = '/placeholder.png';
              }}
              src={formatImageUrl(cover_pages[1])}
            />
          </div>

          {modified_pages?.reverse().map((page: any, index: number) => {
            return (
              <div className="relative" key={index}>
                <Image
                  className={`block w-full book-image img-${index}`}
                  alt="book-image"
                  width={700}
                  height={700}
                  onLoad={handleImageLoad}
                  onError={(e: any) => {
                    console.error('Failed to load image:', e);
                    // Optionally set a fallback image
                    e.target.src = '/placeholder.png';
                  }}
                  priority={true}
                  src={formatImageUrl(page)}
                  style={{ display: 'block' }}
                />

                {pages_dedication_texts
                  .filter((x: any) => x.page == index.toString())[0]
                  ?.dedication_texts?.map((item: any, idx: number) => {
                    let dimensions = JSON.parse(
                      pages_dedication_texts.filter(
                        (x: any) => x.page == index.toString(),
                      )[0]['dimensions'],
                    )
                    let book_img = document.querySelector('.book-image')
                    if (item) {
                      return (
                        <div
                          className="texts absolute"
                          key={idx}
                          data-attribute={`${item.X_coord_percent}`}
                          style={{
                            fontSize:
                              (imageWidth * item.font_size) /
                              pt2px(dimensions.width),
                            textAlign: getTextAlignment(item.text_align),
                            width:
                              (imageWidth * item.max_width) /
                              pt2px(dimensions.width),
                            top: item.Y_coord_percent + '%',
                            lineHeight: item.line_height,
                            color: item.color,
                            whiteSpace: 'pre-wrap',
                            left: item.X_coord_percent + '%',
                            fontFamily: item.font_face,
                            direction: 'ltr',
                          }}>
                          {inputDedication.replace(
                            '{basmti}',
                            name ?? product.replace_name,
                          )}
                        </div>
                      )
                    } else {
                      return <></>
                    }
                  })}
                {pages_predefined_texts
                  .filter((x: any) => x.page == index.toString())[0]
                  ?.predefined_texts?.map((item: any, idx: number) => {
                    let dimensions = JSON.parse(
                      pages_predefined_texts.filter(
                        (x: any) => x.page == index.toString(),
                      )[0]['dimensions'],
                    )
                    if (item) {
                      return (
                        <div
                          className="texts absolute"
                          key={idx}
                          style={{
                            fontSize:
                              (imageWidth * item.font_size) /
                              pt2px(dimensions.width),
                            textAlign: getTextAlignment(item.text_align),
                            width:
                              (imageWidth * item.max_width) /
                              pt2px(dimensions.width),
                            top: item.Y_coord_percent + '%',
                            lineHeight: item.line_height,
                            whiteSpace: 'pre-wrap',
                            color: item.color,
                            left: item.X_coord_percent + '%',
                            fontFamily: item.font_face,
                            direction: 'ltr',
                          }}
                          dangerouslySetInnerHTML={{ __html: item.text }}></div>
                      )
                    } else {
                      return <></>
                    }
                  })}
              </div>
            )
          })}
          <div className="relative start-cover">
            {cover_pages_predefined_texts
              ?.filter((x: any) => x.page == '0')[0]
              ?.predefined_texts?.map((item: any, idx: number) => {
                let dimensions = JSON.parse(
                  cover_pages_predefined_texts.filter(
                    (x: any) => x.page == '0',
                  )[0]['dimensions'],
                )
                return (
                  <div
                    className="texts absolute"
                    key={idx}
                    id={item.X_coord_percent}
                    data-attribute={`${imageWidth}-${item.max_width}-${dimensions.width
                      }-${pt2px(dimensions.width)}`}
                    style={{
                      fontSize:
                        (imageWidth * item.font_size) / pt2px(dimensions.width),
                      textAlign: getTextAlignment(item.text_align),
                      width:
                        (imageWidth * item.max_width) / pt2px(dimensions.width),
                      top: item.Y_coord_percent + '%',
                      lineHeight: item.line_height,
                      whiteSpace: 'pre-wrap',
                      left: item.X_coord_percent * 2 + '%',
                      color: item.color,
                      fontFamily: item.font_face,
                      direction: 'ltr',
                    }}
                    dangerouslySetInnerHTML={{ __html: item.text }}></div>
                )
              })}
            <Image
              alt="cover"
              className="w-full h-full object-cover"
              width={700}
              height={700}
              onLoad={handleImageLoad}
              onError={(e: any) => {
                console.error('Failed to load image:', e);
                // Optionally set a fallback image
                e.target.src = '/placeholder.png';
              }}
              src={formatImageUrl(cover_pages[0])}
            />
          </div>
        </HTMLFlipBook>
        /* tslint:enable */
      )
    }
  }
  return <></>
}
